import * as brand from './colors';
import { typography } from './typography';
import { shadows } from './shadows';
import { overrides } from './overrides';

export const styles = {
  palette: {
    primary: {
      main: brand.ycGreen[900]
    },
    secondary: {
      main: brand.ycRed[500]
    }
  },
  typography,
  shadows,
  overrides
};
